// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"8ec04563","47":"98234034"}[chunkId] + ".chunk.js";
};